import * as React from 'react';
import { Col, Modal, Row, Input, Divider } from 'antd';

import Form, { FormItem } from '../../../components/Form';
import { Title } from '../../../components/Layout/components';

interface ICustomerGroupDetailProps {
  domain: string;
  customerGroup: GQL.ICustomerGroup;
  customerGroupList: Array<GQL.ICustomerGroup>;
  languages: Array<GQL.ILanguage>;
  onSave: (customerGroup: GQL.ICustomerGroup) => void;
  onCancel: () => void;
}

interface ICustomerGroupDetailState {
  customerGroup: GQL.ICustomerGroup;
  currentLanguage: string;
}

export default class CustomerGroupDetail extends React.Component<ICustomerGroupDetailProps, ICustomerGroupDetailState> {

  public constructor(props: ICustomerGroupDetailProps) {
    super(props);

    this.state = {
      customerGroup: props.customerGroup || {},
      currentLanguage: props.languages.map(l => l.value)[0],
    };

    this.onChange = this.onChange.bind(this);
    this.save = this.save.bind(this);
  }

  public render() {
    const { customerGroup } = this.state;

    return (
      <div>
        <Title>
          {customerGroup
            ? `Customer group ${customerGroup.name ? `"${customerGroup.name}"` : ''}`
            : `Customer group`}
        </Title>

        <Divider />
        <Form
          onSubmit={this.save}
          onCancel={this.props.onCancel}
        >
          <FormItem label="Name" required={true}>
            <Input
              autoFocus={true}
              name={'name'}
              placeholder="Customers group name"
              value={customerGroup.name}
              required={true}
              onChange={this.onChange}
            />
          </FormItem>
          <FormItem label="Discount">
            <Input
              name={'discount'}
              type={'number'}
              placeholder="Discount"
              addonAfter={'%'}
              value={customerGroup.discount || undefined}
              onChange={this.onChange}
            />
          </FormItem>
          <FormItem label="Section description">
            <Input.TextArea
              name={'description'}
              placeholder="By adding fields you will enable new section on website dedicated to fill the forms or if you want just inform specific group, you can add this section without publishing fields to fill in."
              value={customerGroup.description || undefined}
              onChange={this.onChange}
            />
          </FormItem>
          <FormItem label="Fields">
            <Input.TextArea
              name={'fields'}
              placeholder="Add fields separated by new line which you want to fill by customer. You can add short description after semi-colon Size of T-shirts (EU);Please specify your t-shirt size. If you want to setup this by customer, you can enable section by filling Section description."
              value={customerGroup.fields || undefined}
              onChange={this.onChange}
            />
          </FormItem>
          <FormItem label="Welcome e-mail">
            <Input.TextArea
              name={'email'}
              placeholder="E-mail which will be sent after person is added to this group"
              value={customerGroup.email || undefined}
              onChange={this.onChange}
            />
          </FormItem>
          <FormItem label="Pohoda IDS">
            <Input
              name={'PohodaIDS'}
              placeholder="Pohoda IDS"
              value={customerGroup.PohodaIDS || undefined}
              onChange={this.onChange}
            />
          </FormItem>
        </Form>
      </div>
    );
  }

  private onChange(e: any, language?: string) {
    const { name, value, checked } = e.target;

    const inputValue = (value !== undefined ? value : checked);
    const newValue = (language
      ? { [name]: { ...this.state.customerGroup[name], [language]: inputValue } }
      : { [name]: value });
    this.setState({
      customerGroup: { ...this.state.customerGroup, ...newValue }
    });
  }

  private async save() {
    this.props.onSave({ ...this.state.customerGroup });
  }
}



// WEBPACK FOOTER //
// ./src/scenes/CustomerGroup/CustomerGroupDetail/CustomerGroupDetail.tsx